"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ZWFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_257)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_257`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.959991 0H35.04V24.0003H-0.959991V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.959991 3.43555H35.04V6.87158H-0.959991V3.43555ZM-0.959991 17.1797H35.04V20.6157H-0.959991V17.1797Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.959991 0H35.04V3.43603H-0.959991V0Z",
					fill: "#057F44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.959991 6.87207H35.04V10.3081H-0.959991V6.87207ZM-0.959991 13.7442H35.04V17.1802H-0.959991V13.7442Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.959991 20.6162H35.04V24.0002H-0.959991V20.6162Z",
					fill: "#057F44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.516 11.9998L6.51627 23.9995H-0.959991V0H6.51627L18.516 11.9998Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.0401 11.9997L5.0401 23.9997H6.51575L18.5158 11.9997L6.51575 -0.000244141H5.0401L17.0401 11.9997Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.24459 8.24316L7.17686 11.1128H10.1945L7.75335 12.8865L8.6857 15.7562L6.24459 13.9826L3.80333 15.7562L4.73582 12.8865L2.29471 11.1128H5.31217L6.24459 8.24316Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.80926 12.2344L6.37933 11.3736C6.37933 11.3736 6.19982 9.68925 6.18893 9.63222C6.10645 9.19769 5.72465 8.86926 5.26621 8.86926C4.74759 8.86926 4.32705 9.28973 4.32705 9.80843C4.32705 9.89442 4.33956 9.97732 4.36122 10.0565L3.67996 10.7424H4.89138C4.89138 11.9997 3.95313 11.9997 3.95313 13.2519L4.47358 14.5041H7.60404L8.1259 13.2519H8.12561C8.17655 13.135 8.2093 13.0109 8.22272 12.8841C8.67251 12.7021 8.80926 12.2344 8.80926 12.2344Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_257`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ZWFlag };
